






















export default
  name: 'CartPankuzu'

  props:
    index:
      type: Number
      default: 1
